/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Incidents API
 * AV Services Incidents management API
 * OpenAPI spec version: 1.0
 */

export interface IncidentDeviceMakeDto {
  /** UUID of the device maker */
  id: string;
  /** Name of the device maker */
  name: string;
  /**
   * UUID of the client that owns the maker
   * @nullable
   */
  ownerClientId?: string | null;
}
